import Client from './Clients/AxiosClient'
const resource = '/api/v1/admin/order/order-histories'

export default {
  get(payload) {
    return Client.get(`${resource}`, {
      params: {
        page: payload.page || 1,
        page_size: payload.page_size || 10,
        search: payload.search || "",
      },
    });
  },
  show(kode_reference) {
    return Client.get(`/api/v1/payment/detail/${kode_reference}`)
  },
}
